import { TOWN_INK } from "@town/contracts";

/**
 * Overlay colours for the office canvases, with the one outline ink the
 * architecture atlas uses. Walls, floors, glass and doors take their colours
 * from the floor plan palette in @town/contracts, and furniture from its
 * catalog model.
 */
export const PIXEL = {
  ink: TOWN_INK,
  highlight: "rgba(0, 184, 236, 0.35)",
  highlightLine: "#00b8ec",
  invalid: "rgba(232, 84, 84, 0.35)",
  invalidLine: "#e85454",
  speaking: "#57d38c",
} as const;
